module.exports = __webpack_public_path__ + "static/img/y73.1a817db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y73.jpg
// module id = MJpp
// module chunks = 1